import { cn } from '@/shared/lib/cn';

/** Акварели фирменного стиля заказчика (автор — Лена Кюркина). Лежат в `public/illustrations`. */
export type IllustrationName =
  | 'family'
  | 'mother-child'
  | 'mother-daughter'
  | 'couple'
  | 'grandpa-child'
  | 'grandparents'
  | 'grandparents-flower'
  | 'girl-cat'
  | 'boy-reading'
  | 'house'
  | 'books'
  | 'cat-sleeping'
  | 'cat-ginger'
  | 'dog'
  | 'bird-teal'
  | 'bird-mint'
  | 'star-mint'
  | 'star-honey'
  | 'heart-sage'
  | 'heart-blush'
  | 'forget-me-not'
  | 'flower-pink'
  | 'flower-blue'
  | 'leaf-olive'
  | 'leaf-sage'
  | 'leaf-light';

interface IllustrationProps {
  name: IllustrationName;
  /** Высота в пикселях; ширина подстраивается по пропорции. */
  size?: number;
  className?: string;
  /** Осмысленное описание. Пустая строка (по умолчанию) прячет картинку от скринридера. */
  alt?: string;
}

export function Illustration({ name, size = 56, className, alt = '' }: IllustrationProps) {
  return (
    <img
      src={`/illustrations/${name}.webp`}
      alt={alt}
      aria-hidden={alt === '' ? true : undefined}
      loading="lazy"
      decoding="async"
      style={{ height: size }}
      className={cn('w-auto max-w-full select-none', className)}
      draggable={false}
    />
  );
}
